// ======================================================================
// File Name       : LoadingOverlay
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

const LoadingOverlay = ({ active, spinner, text, zIndex = 800, style, children }) => (
  <div className="lo-wrapper" style={style}>
    {children}
    {active && (
      <div className="lo-overlay" style={{ zIndex }}>
        {spinner && <div className="lo-spinner" />}
        {text && <div className="lo-text">{text}</div>}
      </div>
    )}
  </div>
);

export default LoadingOverlay;
